module.exports = __webpack_public_path__ + "static/media/baseline-exit.36c3400b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/baseline-exit.svg
// module id = 54
// module chunks = 0